/**
 * Landing Page Component
 *
 * Main entry point for the Concierge application landing page.
 * Displays marketing content and navigation to authentication.
 */

import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import FeaturedRepos from '../components/FeaturedRepos';
import PrivateRepo from '../components/PrivateRepo';
import Diagrams from '../components/Diagrams';
import ChatSection from '../components/ChatSection';
// import GoogleCalendarSection from '../components/GoogleCalendarSection';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="landing-root min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <FeaturedRepos />
        <PrivateRepo />
        <Diagrams />
        <ChatSection />
        {/* <GoogleCalendarSection /> */}
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
